import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;

  @media screen and (max-width: 400px) {
    gap: 8px;
  }
`;

export const WalletContainer = styled.div`
  display: flex;
  height: 52px !important;
  gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 1;
  padding: 8px 16px;
  border-radius: 12px;
  background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%);

  @media screen and (max-width: 400px) {
    gap: 4px;
  }

  @media screen and (max-width: 390px) {
      svg {
          width: 20px;
      }
  }

  @media screen and (max-width: 330px) {
  padding: 3px 6px;
  }
`

export const WalletDataContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const WalletTitle = styled.div`
  color: #FFF;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const TopUpAndWithDrawContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`

export const ActionButton = styled.div`
  display: flex;
  height: 52px;
  gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 1;
  border-radius: 12px;
  background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%);

  @media screen and (max-width: 400px) {
    gap: 4px;
  }

  @media screen and (max-width: 390px) {
      svg {
          width: 20px;
      }
  }

  @media screen and (max-width: 330px) {
  padding: 3px 6px;
  }
`;

export const Text = styled.div`
padding-left: 4px;
color:  #13100F;
text-align: center;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: normal;

@media screen and (max-width: 390px) {
  font-size: 12px;
}

@media screen and (max-width: 340px) {
padding-left: 0;
}

@media screen and (max-width: 340px) {
font-size: 9px;
}
`;

export const BalanceText = styled(Text)`
  flex: 1;
  text-align: left;
  padding: 0;
  position: relative;
  color: #13100F;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;